import { Action } from '@/interfaces/meeting/details';

export const findById = (items: Action[], id: string): Action | undefined => {
  if (!items) {
    return;
  }

  for (const item of items) {
    // Test current object
    if (item.id === id) {
      return item;
    }

    // Test children recursively
    if (item.children) {
      const child = findById(item.children, id);
      if (child) {
        return child;
      }
    }
  }
}